.vc-switch-slider {
    transition: 100ms transform ease-in-out;
}
